import * as yup from "yup";

import * as RHFSafetyInfoValidationRules from "@/utils/validation/schemas/safetyInfo.RHF";

export const SafetyInfoFormValidationSchema = yup.object({
    search: RHFSafetyInfoValidationRules.safetyInfoSearch
});

export type SafetyInfoFormValues = yup.InferType<
    typeof SafetyInfoFormValidationSchema
>;
